import { useCallback } from "react";

const useExternalLink = (url: string) => {
  const redirectToExternalLink = useCallback(() => {
    window.open(url, "_blank");
  }, [url]);

  return redirectToExternalLink;
};

export default useExternalLink;
